import { render, staticRenderFns } from "./home-section-add.component.vue?vue&type=template&id=1875f31d&scoped=true"
import script from "./home-section-add.component.vue?vue&type=script&lang=ts"
export * from "./home-section-add.component.vue?vue&type=script&lang=ts"
import style0 from "./home-section.style.scss?vue&type=style&index=0&id=1875f31d&prod&scoped=true&lang=scss&external"
import style1 from "./home-section-add.component.vue?vue&type=style&index=1&id=1875f31d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1875f31d",
  null
  
)

export default component.exports